<hdi-page *ngIf="!isLoadingPlaceholder; else loadingPage">
  <hdi-spinner *ngIf="isLoading" />
  <header class="header">
    <ng-container
      *ngIf="mainMenu?.length && flyoutData?.length"
    >
      <hdi-top-bar
        [mainMenu]="mainMenu"
        [flyoutData]="flyoutData"
      ></hdi-top-bar>
    </ng-container>
  </header>

  <main class="main">
    <router-outlet></router-outlet>
  </main>

  <footer>
    <div class="container">
      <hdi-footer [caasData]="footer"></hdi-footer>
    </div>
  </footer>
  <hdi-to-top-button></hdi-to-top-button>
</hdi-page>
<!-- Loading Placeholder -->
<ng-template #loadingPage>
  <hdi-page-loader></hdi-page-loader>
  <router-outlet (activate)="onComponentLoaded()"></router-outlet>
</ng-template>

<hdi-modal
  *ngIf="video"
  [type]="ModalType.VIDEO"
  [videoSrc]="video.videoSrc"
  [videoId]="video.videoId"
  [showModal]="showModal"
  [thumbnailSrc]="video.thumbnailSrc"
  (closeModalTrigger)="closeModal($event)"
>
  <div class="header-content">
    <ng-content select=".header-content"></ng-content>
  </div>
  <ng-content></ng-content>
</hdi-modal>
